export const LOADING = 'LOADING'
export const SUCCESS = 'SUCCESS'
export const FAILED = 'FAILED'
export const ERROR = 'ERROR'
export const INFO = 'INFO'